import axios from "axios";

// export const URL_DEFAULT ='/query/';
export const URL_DEFAULT ='https://73kvartir.ru/query/';


// Функция запроса для получения списка каталога (только активные объекты)
export async function List() {

    let data = {type : "siteList"};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data;

    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}
// Функция запроса для получения полного списка каталога
export async function ListAll() {
    let data = {type : "listAll"};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data;

    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}
// Функция запроса для выполнения запроса по определённому id 
export async function ItsItem({id}) {
    let data = {type : "itsItem", id:id};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data;

    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

// Функция запроса для отправки сообщения от формы обратной связи
export async function MailGo({data}) {
    
    
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "mail.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data;

    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

// Функция запроса для выполнения запроса на вход
export async function LoginIn(data) {
    data.type = "loginIn";
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

// Функция запроса по входу из админки
export async function exitUser(id) {
    const data = { type : "exitUser"};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + 'index.php',
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}


// Функция запроса по удалению записи 
export async function DeleteObject(id) {
    const data = {id:id, type : "deleteObj"};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

// Функция запроса по добавлению объекта
export async function AddObj(domain) {
    const formData = new FormData();

    // Добавляем текстовые данные
    for (const key in domain) {
        if (domain[key] !== undefined && domain[key] !== null) {
            if (typeof domain[key] === 'object' || Array.isArray(domain[key])) {
                // Если это объект или массив, сериализуем его в JSON
                formData.append(key, JSON.stringify(domain[key]));
            } else {
                // В противном случае, добавляем как есть
                formData.append(key, domain[key]);
            }
        }
    }

    // Добавляем изображения
    if (domain.images && domain.images.length > 0) {
        domain.images.forEach((image, index) => {
            // Добавляем файлы в FormData
            formData.append(`images[]`, image.file);
        });
    }

    formData.append('reqestsType', 'addObj');

    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: formData,
        });

        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}




// Функция запроса на редактированию  объекта
export async function UpdateObj(domain) {
    const formData = new FormData();

    // Добавляем текстовые данные
    for (const key in domain) {
        if (domain[key] !== undefined && domain[key] !== null) {
            if (typeof domain[key] === 'object' || Array.isArray(domain[key])) {
                // Если это объект или массив, сериализуем его в JSON
                formData.append(key, JSON.stringify(domain[key]));
            } else {
                // В противном случае, добавляем как есть
                formData.append(key, domain[key]);
            }
        }
    }

    // Добавляем изображения
    if (domain.images && domain.images.length > 0) {
        domain.images.forEach((image, index) => {
            // Добавляем файлы в FormData
            formData.append(`images[]`, image.file);
        });
    }

    formData.append('reqestsType', 'updateObj');
    
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            data: formData,
        });
        
        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}

// Функция запроса на редактированию  объекта
export async function UpdateStatus(id, status) {
    
    const data = {id:id, type : "status", status:status};
    try {
        const response = await axios({
            method: 'POST',
            url: URL_DEFAULT + "index.php",
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
        });
        
        return response.data.success;
    } catch (error) {
        console.error(error);
        throw error; // Передаем ошибку дальше
    }
}